import { render, staticRenderFns } from "./RealtimeMonitor.vue?vue&type=template&id=65ba6ce1&"
import script from "./RealtimeMonitor.vue?vue&type=script&lang=js&"
export * from "./RealtimeMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports